import React from "react";

const Button = ({
  className,
  href,
  target,
  rel,
  modal,
  onClick,
  type,
  altStyle,
  hasIcon,
  text,
}) => {
  const Tag = href ? "a" : "button";

  return (
    <Tag
      className={`group px-4 py-2 min-w-[211px] h-[51px] inline-flex items-center justify-center text-center uppercase tracking-widest no-underline ${
        altStyle
          ? "bg-primary-400 hover:bg-primary-400 text-primary-500 hover:text-primary-500"
          : "bg-primary-500 hover:bg-primary-400 text-white hover:text-white"
      } ${className || ""}`}
      href={href}
      target={target}
      rel={rel}
      data-modal-open={modal}
      onClick={onClick}
      type={type}
      altStyle={altStyle}
      hasIcon={hasIcon}
    >
      {text}

      {hasIcon === false ? (
        ""
      ) : (
        <svg
          width="30"
          height="9"
          viewBox="0 0 30 9"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="ml-2.5"
        >
          <path
            d="M29.3536 4.85355C29.5488 4.65829 29.5488 4.34171 29.3536 4.14645L26.1716 0.964465C25.9763 0.769203 25.6597 0.769203 25.4645 0.964465C25.2692 1.15973 25.2692 1.47631 25.4645 1.67157L28.2929 4.5L25.4645 7.32843C25.2692 7.52369 25.2692 7.84027 25.4645 8.03553C25.6597 8.23079 25.9763 8.23079 26.1716 8.03553L29.3536 4.85355ZM2.18557e-08 5L29 5L29 4L-2.18557e-08 4L2.18557e-08 5Z"
            className="fill-current text-gray-50 transition-colors duration-300 ease-linear"
          />
        </svg>
      )}
    </Tag>
  );
};

export default Button;
